import React, { Suspense } from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";

// Initialize i18n AFTER React is imported but BEFORE components
import "./i18n/config";
import "./index.css";
import LandingPage from "./pages/LandingPage";
import Home from "./pages/Home";
import History from "./pages/History";
import Profile from "./pages/Profile";
import TalkingPhoto from "./pages/TalkingPhoto";
import CreateVideo from "./pages/CreateVideo";
import Chat from "./pages/Chat";
import Avatars from "./pages/Avatars";
import GeneratedVideo from "./pages/GeneratedVideo";
import Streaming from "./pages/Streaming";
import LiveStreaming from "./pages/LiveStreaming";
import PrivacyPolicy from "./pages/Privacy";
import TermsOfUse from "./pages/Terms";
import Contactus from "./pages/Contactus";
import ContactGreek from "./pages/ContactGreek";
import FaqGreek from "./pages/FaqGreek";

import Packages from "./pages/packages";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <Suspense fallback={<div>Loading...</div>}>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/contact" element={<Contactus />} />
        <Route path="/Portal/index.html" element={<Home />} />
        <Route path="/packages" element={<Packages />} />

        <Route path="/Portal/history" element={<History />} />
        <Route path="/Portal/profile" element={<Profile />} />
        <Route path="/Portal/talkingphoto" element={<TalkingPhoto />} />
        <Route path="/Portal/avatars" element={<Avatars />} />
        <Route path="/Portal/streaming" element={<Streaming />} />
        <Route path="/Portal/createvideo" element={<CreateVideo />} />
        <Route path="/Portal/generatedvideo" element={<GeneratedVideo />} />
        <Route path="/Portal/livestreaming" element={<LiveStreaming />} />
        <Route path="/Portal/chat" element={<Chat />} />
        <Route path="/Portal/privacy" element={<PrivacyPolicy />} />
        <Route path="/Portal/terms" element={<TermsOfUse />} />
        <Route path="/Portal/contact" element={<ContactGreek />} />
        <Route path="/Portal/faq" element={<FaqGreek />} />
      </Routes>
    </BrowserRouter>
  </Suspense>
);
